import VideosOverview from '../../features/videos/layouts/overview';

export default function VideosPage() {
    return <VideosOverview />;
}
